class DataCache {
  constructor() {
    this.cache = new Map();
    this.timestamps = new Map();
    this.defaultTTL = 5 * 60 * 1000; // 5 minutes default
  }

  set(key, data, ttl = this.defaultTTL) {
    this.cache.set(key, data);
    this.timestamps.set(key, Date.now() + ttl);
  }

  get(key) {
    if (!this.cache.has(key)) {
      return null;
    }

    const expiresAt = this.timestamps.get(key);
    if (Date.now() > expiresAt) {
      this.cache.delete(key);
      this.timestamps.delete(key);
      return null;
    }

    return this.cache.get(key);
  }

  invalidate(key) {
    this.cache.delete(key);
    this.timestamps.delete(key);
  }

  invalidatePattern(pattern) {
    const regex = new RegExp(pattern);
    for (const key of this.cache.keys()) {
      if (regex.test(key)) {
        this.cache.delete(key);
        this.timestamps.delete(key);
      }
    }
  }

  clear() {
    this.cache.clear();
    this.timestamps.clear();
  }

  has(key) {
    if (!this.cache.has(key)) {
      return false;
    }
    const expiresAt = this.timestamps.get(key);
    return Date.now() <= expiresAt;
  }
}

export const dataCache = new DataCache();

export const withCache = async (key, fetchFn, ttl) => {
  const cached = dataCache.get(key);
  if (cached !== null) {
    return cached;
  }

  const data = await fetchFn();
  dataCache.set(key, data, ttl);
  return data;
};
